.form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* The rows draw their own top rules; the box closes them. */
.summary {
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  overflow: hidden;
}

.summary > div > :first-child {
  border-top: 0;
}
